import { render, staticRenderFns } from "./statisticMonth.vue?vue&type=template&id=ddf0b76a&scoped=true"
import script from "./statisticMonth.vue?vue&type=script&lang=js"
export * from "./statisticMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf0b76a",
  null
  
)

export default component.exports